<template>
  <div class="LoginFrame">
    <a-form-model class="loginFrom"
                  ref="loginFrom"
                  :model="loginInfo"
                  :rules="LoginRules"
                  >
      <div class="title">RTU后台管理</div>
      <a-form-model-item  class="form-item" prop="user">
        <a-input v-model='loginInfo.user' placeholder="请输入账号" type="text" autocomplete="off" has-feedback>
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-model-item>

      <a-form-model-item  class="form-item" prop="password" has-feedback>
        <a-input-password v-model="loginInfo.password" placeholder="请输入密码" type="password" autocomplete="off">
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>

      <a-form-model-item class="form-item">
        <a-button
          class="login-btn"
          @click="handleLoginClick('loginFrom')"
          :loading="loading"
        >
        登录
        </a-button>
      </a-form-model-item>

    </a-form-model>
  </div>
</template>

<script>
import { login } from 'api/login'
import cache from 'utils/cache'
import { clearSsoMode } from 'utils/sso'
import { asyncRoutes } from "@/router";
export default {
  name: "LoginFrame",
  data() {
    // ------------表单验证
    let checkPending;
    let validateUser = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('账号不能为空'));
      }else {
        callback()
      }
    };
    let validatePassword = (rule, value, callback) => {
      clearTimeout(checkPending);
      if (value == '') {
        callback(new Error('密码不能为空'));
      }else {
        callback()
      }
    };
    //-----------------
    return {
      loading: false,
      loginInfo: {
        user: '',
        password: ''
      },
      LoginRules: {
        user: [
          {
            validator: validateUser,
            trigger: 'change'
          }
        ],
        password: [
          {
            validator: validatePassword,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    /**
     * 逻辑区
     */
    handleLoginClick(DOM) {
      this.$refs[DOM].validate(valid => {
        if (valid) {
          console.log(11111)
          console.log(process.env.APP_API)
          this.userLogin(this.loginInfo.user, this.loginInfo.password)
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    test(){
      this.$router.replace({
        path: '/sys/user'
      })
    },
    /**
     * 接口区
     */
    // 登录
    userLogin(user,password) {
      this.loading = true;
      login(user, password)
        .then(res => {
          console.log(res);
          this.loading = false
          if (res.code == 1003){
            this.$message.error(res.message);
          }else if(res.code == 0){
            clearSsoMode();
            cache.set("device-nickname", res.data.nickname);
            cache.set("device-id", res.data.id);
            const token = res.data.token || res.data.name || '';
            cache.set('device-name', res.data.name);
            cache.set('device-Token', token);
            cache.set("device-menus", res.data.menus || []);
            cache.set("device-authorizes", res.data.authorizes || []);

            const firstMenuPath = (res.data.menus && res.data.menus.length > 0)
              ? String(res.data.menus[0].url || '').toLowerCase()
              : '/rmsprofile';

            this.$router.replace({
              path: firstMenuPath.startsWith('/') ? firstMenuPath : `/${firstMenuPath}`
            })
            this.$message.success('登录成功');
          }else{
            this.$message.warn('登录失败，服务器异常！');
          }

        })
        .catch(err => {
          console.log(err)
          this.loading = false
          if (err.code != 1003){
            this.$message.error('登录失败，服务器异常！');
          }else {
            this.$message.error(err.message);
          }

        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .LoginFrame {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 300px;
    background-color: rgba($color: #fff, $alpha: .46);
    border-radius: 5px;
  }
  .loginFrom {
    padding: 18px 30px;
    .form-item {
      margin-bottom: 10px;
      .login-btn {
        width: 100%;
        background: #F19470;
        color: #fff;
        border: none;
      }
    }
  }
  .title{
    width: 100%;
    height: 50px;
    line-height: 40px;
    text-align: center;
    font-weight: 600;
    font-size: 25px;
    color: white;
  }
</style>
